'use client';

import { cn } from '@coas/ui/lib';
import * as React from 'react';

export type AuthButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    isLoading?: boolean;
};

export default React.forwardRef<HTMLButtonElement, AuthButtonProps>(
    ({ isLoading, disabled, className, children, ...rest }, ref) => (
        <button
            ref={ref}
            disabled={disabled ?? isLoading}
            className={cn(
                'bg-neutral-950 py-2 font-semibold text-[16px] text-neutral-50 uppercase',
                'outline-2 outline-neutral-950 outline-offset-2 focus-visible:outline',

                isLoading && 'animate-pulse',
                (disabled ?? isLoading) && 'cursor-not-allowed opacity-60',

                className,
            )}
            {...rest}
        >
            {children}
        </button>
    ),
);
